import React from "react";
import { Tab, Tabs, Paper } from "@material-ui/core";
import { ImSpinner3 } from 'react-icons/im';

import './urlDataTabs.style.css'


const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="url-tabpanel"
      hidden={value !== index}
      id={`url-tabpanel-${index}`}
      aria-labelledby={`url-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div>{children}</div>
      )}
    </div>
  );
};

const PrettyPrintJson = ({ data }) => (<div><pre>{JSON.stringify(data, null, 2)}</pre></div>);

const UrlDataTabs = ({
  screenshotLink,
  setShowImageModal,
  metaData,
  pageSource,
  analyserResult,
  isLoading
}) => {
  const [value, setValue] = React.useState(0);
  const tabOptions = [
    { name: 'Screenshot', disabled: false },
    { name: 'Metadata', disabled: false },
    { name: 'Page Source', disabled: false },
    { name: 'Analyser Results', disabled: false },
  ];

  return (
    <div className='tab-container'>
      <Paper square>
        <Tabs
          value={value}
          TabIndicatorProps={{
            style: {
              backgroundColor: "#055bb5",
            }
          }}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          {
            tabOptions.map((item, index) => {
              return (
                <Tab label={item.name} disabled={item.disabled} />)
            })
          }
        </Tabs>
        <TabPanel value={value} index={0}>
          <div className='panel-container'>
            <img
              className='screenshot'
              src={screenshotLink}
              alt="Screenshot"
              onClick={() => setShowImageModal(true)}
            />
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <div className='panel-container'>
            <PrettyPrintJson data={metaData} />
          </div>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <div className='panel-container'>
            {pageSource}
          </div>
        </TabPanel>
        <TabPanel value={value} index={3}>
          <div className='panel-container'>
            {isLoading ? (
              <div className='analiser-result-spinner-box'>
                <ImSpinner3 className='spinner spin' />
              </div>
            ) : (
                <div className='analiser-result-box'>
                  <PrettyPrintJson data={analyserResult} />
                </div>
              )}
          </div>
        </TabPanel>
      </Paper>
    </div >
  );
};

export default UrlDataTabs;
